import {FC, useState, createContext, useContext, useMemo, Dispatch, SetStateAction} from 'react'
import {WithChildren} from '../../../../../_metronic/helpers'

type ListViewContextProps = {
  displayMode: 'list' | 'grid' | string
  setDisplayMode: Dispatch<SetStateAction<'list' | 'grid' | string>>
  typeProduct: 1 | 2 | number
  setTypeProduct: Dispatch<SetStateAction<1 | 2 | number>>
  isArchived: boolean
  setArchived: Dispatch<SetStateAction<boolean>>
}

const initialListView: ListViewContextProps = {
  displayMode: 'list',
  typeProduct: 1,
  setDisplayMode: () => {},
  setTypeProduct: () => {},
  isArchived: false,
  setArchived: () => {},
}

const ListViewContext = createContext<ListViewContextProps>(initialListView)

const ListViewProvider: FC<WithChildren> = ({children}) => {
  const view = localStorage.getItem('PRODUCT-VIEW-KEY')
  const [displayMode, setDisplayMode] = useState<'list' | 'grid' | string>(view || 'list')
  const [typeProduct, setTypeProduct] = useState<1 | 2 | number>(1)

  const [isArchived, setArchived] = useState<boolean>(initialListView.isArchived)

  const contextValue = useMemo(
    () => ({
      displayMode,
      setDisplayMode,
      isArchived,
      setArchived,
      typeProduct,
      setTypeProduct,
    }),
    [isArchived, setArchived, displayMode, setDisplayMode, typeProduct, setTypeProduct]
  )

  return <ListViewContext.Provider value={contextValue}>{children}</ListViewContext.Provider>
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}
